import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip
} from "reactstrap";

import { useDispatch } from "react-redux";

import { decryptedValue, isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { addUser, deleteUser, editUser, getUser } from "http/fundLync/user.helper";
import { getRoleByEntityType } from "../../http/fundLync/role.helper"
import {reqConsent } from "http/fundLync/entityAndAddress.helper";
import { changeUserStatus } from "../../http/fundLync/entityAndAddress.helper";

import Switch from "react-switch";
import CommonDialog from "components/Common/CommonDialog";

const Offsymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginRight:'10px'
            }}
        >
            {" "}
            Inactive
        </div>
    );
};

const OnSymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginLeft:'10px'
            }}
        >
            {" "}
            Active
        </div>
    );
};

const TableActionsComponentToggle = ({props, handleStatusChange}) => {
    const [checked, setChecked] = useState(props.isActive);
    const newObj = {};
    for (const key in props) {
        if (props[key] !== null) {
            newObj[key] = props[key];
        }
    }
    useEffect(() => {
        setChecked(props.isActive)
    }, [props]);
    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2"
                    onColor="#21aa47"
                    width={80}
                    onChange={() => {
                        newObj.isActive = !props.isActive
                        props.isActive = !props.isActive
                        setChecked(newObj.isActive)
                        handleStatusChange(newObj);
                    }}
                    checked={checked}
                    />
            </DropdownToggle>
        </UncontrolledDropdown>
    )
}

const UsersTable = ({ entityType,isOpen,onAccordionToggle })=> {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAddAddressOpen, setAddAddressOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userList, setUserList] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const dispatch = useDispatch();
  const [userEditData, setUserEditData] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNewUserPermission, setNewUserPermission] = useState(false)
  const [isRoleList, setRoleListPermission] = useState(false)
  const [roleList, setRoleList] = useState([])
  const [selectedViewUser, setSelectedViewUser] = useState(null);
  const [isViewOpen, setViewOpen] = useState(false);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [isPermissionReqConsent, setIsPermissionReqConsent] = useState(false);
  const [isUserStatusChangePerm, setIsUserStatusChangePerm] = useState(false);

  
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstName: userEditData && userEditData[0]?.firstName || "",
      lastName: userEditData && userEditData[0]?.lastName || "",
      email: userEditData && userEditData[0]?.email || "",
      mobileNo: userEditData && userEditData[0]?.mobileNo || "",
      id: userEditData && userEditData[0]?.id || "",
      roleId: userEditData && userEditData[0]?.roleId || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter First Name"),
      lastName: Yup.string().required("Please Enter Last Name"),
      email: Yup.string().required("Please Enter Email"),
      mobileNo: Yup.string()
        .required("Please Enter Mobile Number")
        .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
      roleId: isRoleList
        ? Yup.string().required("Please Select Role Type")
        : Yup.string(),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const entity = {
          id: values.id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobileNo: String(values.mobileNo),
          entityId:userEditData[0]?.entityId,
        };
        if (isRoleList) {
          entity.roleId = values.roleId
        } else {
          entity.roleId = 2
        }
        editUser(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              validation.resetForm()
              setToastInfo({
                message: "User Saved",
                showToast: true,
                role: "success",
              })
              getUser({ entityId })
              .then((response) => {
                if (response.code == 200 && response.status) {
                  setUserList(response?.data?.data)
                }
              }).catch((error) => {
                console.log(error)
              })
              setAddAddressOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        const entity = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobileNo: String(values.mobileNo),
          entityId:entityId,
        };
        if (isRoleList) {
          entity.roleId = values.roleId
        } else {
          entity.roleId = 2
        }
        addUser(entity)
          .then((response) => {
            if (response.status) {
              validation.resetForm()
              setToastInfo({
                message: "User Saved",
                showToast: true,
                role: "success",
              })
              getUser({ entityId })
                .then((response) => {
                  if (response.status) {
                    setUserList(response?.data?.data)
                  }else{
                    setUserList([])
                  }
                }).catch((error) => {
                  console.log(error)
                })
              setAddAddressOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }

    },
  });

  useEffect(() => {
    if (isOpen) {
    getUser({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
     } checkPermissions()
  }, [isOpen,entityId]);

  useEffect(() => {
    checkPermissions()
  }, [entityType]);

  const checkPermissions = async () => {
    const isNewUserpermission = await isPermission("authorised_person", "create_permission")
    const isRoleListPermission = await isPermission("roles", "list_permission")
    const isReqConsPermission = await isPermission("req_consent", "create_permission")
    const isUserStatus = await isPermission("platform_user", "create_permission")

    setIsUserStatusChangePerm(isUserStatus)
    setIsPermissionReqConsent(isReqConsPermission)
    setRoleListPermission(isRoleListPermission)
    setNewUserPermission(isNewUserpermission)
    if (isRoleListPermission) {
      getRoleByEntityType({searchKey:entityType})
        .then((response) => {
          if (response.status) {
            setRoleList(response.data.data)
          }
        })
        .catch((error) => {

        });
    }
  }

  const handleCustomerClicks = () => {
    setAddAddressOpen(true);
    setIsEdit(false);
    setUserEditData(null);
  };

  const handleCancelrClicks = () => {
    setAddAddressOpen(false);
    setUserEditData(null);
  };

  const EditAddress = (id) => {
    setIsEdit(true);
    const filteredData = userList.filter((elem) => {
      return elem.id == id;
    });
    setUserEditData(filteredData);
    setAddAddressOpen(true);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setAddAddressOpen(false);
    setIsEdit(false);
    if (onAccordionToggle) {
      onAccordionToggle(!isDropdownOpen);
    }
  };
  const ViewUser = (id) => {
    const selectedView = userList.find((elem) => elem.id == id);
    setSelectedViewUser(selectedView);
    setViewOpen(true);
  };

  const handleChange = async (id) => {
    let res = await reqConsent({ id })
    if (res.status) {
      setToastInfo({
        message: res.message,
        showToast: true,
        role: "success",
      });
      getUser({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    } else {
      setToastInfo({
        message: res.message,
        showToast: true,
        role: "error",
      });
    }
  };

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      changeUser(data)
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const handleStatusChange = (data) => {
    let message = 'Are you sure you want to de-activate user?'
    if (data.isActive) {
      message = 'Are you sure you want to activate the user?'
    }
    setShowCommonDialog({ isShow: true, message, data })
  };

  const changeUser = (data) => {
    let payLoad = {
      userId: data.id,
      isActive: data.isActive
    }
    changeUserStatus(payLoad).then((res) => {
      if (res && res.status) {
        if (data?.isActive) {
          setToastInfo({
            message: 'User activated',
            showToast: true,
            role: "success",
          });
        } else {
          setToastInfo({
            message: 'User de-activated',
            showToast: true,
            role: "success",
          });
        }
      } else {
        setToastInfo({
          message: 'Failed to change user status',
          showToast: true,
          role: "error",
        });
      }
    }).catch((err) => {
      setToastInfo({
        message: 'Failed to change user status',
        showToast: true,
        role: "error",
      });
    })
  };

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteUser({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "User Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            getUser({ entityId })
              .then((response) => {
                if (response.status) {
                  setUserList(response?.data?.data)
                } else {
                  setUserList([])
                }
              }).catch((error) => {
                console.log(error)
              })
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <div>
      <div>
        <Card style={{ padding: "10px" }}>
          <div
            className="d-flex justify-content-between mt-1"
            style={{ cursor: "pointer" }}
            onClick={toggleDropdown}
          >
            <div>
              <h5>User Details</h5>
            </div>
            <div className="me-2">
              <i
                className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {isViewOpen && selectedViewUser && (
              <div>
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => setViewOpen(false)}
                    >
                      close
                    </Button>
                </div>
              <Row className="mb-3">
                <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Fisrt Name</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewUser.firstName || ''}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">Last Name</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewUser.lastName}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">Email</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewUser.email}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">Mobile no.</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewUser.mobileNo}</span>
                </Col>
              </Row>
              </div>
            )}
          {isAddAddressOpen && (
            <div>
              <div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {/* <div>
                    <h4 style={{ marginTop: "1%" }}> User Details</h4>
                  </div> */}

                  <Row className="mb-3">

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">First Name*</Label>
                      <Input
                        name="firstName"
                        type="text"
                        placeholder="Enter First Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.firstName || ""}
                        invalid={
                          validation.touched.firstName &&
                          validation.errors.firstName
                        }
                      />
                      {validation.touched.firstName &&
                        validation.errors.firstName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.firstName}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">Last Name*</Label>
                      <Input
                        name="lastName"
                        type="text"
                        placeholder="Enter Last Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lastName || ""}
                        invalid={
                          validation.touched.lastName &&
                          validation.errors.lastName
                        }
                      />
                      {validation.touched.lastName &&
                        validation.errors.lastName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.lastName}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">Email*</Label>
                      <Input
                        name="email"
                        type="email"
                        placeholder="Enter Email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">Mobile No.*</Label>
                      <Input
                        name="mobileNo"
                        type="text"
                        placeholder="Enter Mobile No"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.mobileNo || ""}
                        invalid={
                          validation.touched.mobileNo &&
                          validation.errors.mobileNo
                        }
                      />
                      {validation.touched.mobileNo &&
                        validation.errors.mobileNo ? (
                        <FormFeedback type="invalid">
                          {validation.errors.mobileNo}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    {isRoleList && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Role*</Label>
                        <Input
                          name="roleId"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roleId || ""}
                          invalid={validation.touched.roleId && validation.errors.roleId}
                        >
                          <option value="" disabled>Select Role Type</option>
                          {roleList.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.roleId && validation.errors.roleId ? (
                          <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                        ) : null}
                      </Col>
                    )}

                  </Row>

                  <div className="mb-3 d-flex" style={{ width: "100%" }}>
                  </div>

                  <Row className="mb-3">
                    <Col>
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-outline-secondary save-customer me-2"
                          onClick={handleCancelrClicks}
                        >
                          Cancel
                        </button>
                        {isEdit ? (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Update
                          </button>
                          ): (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          )}
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          )}
          {isDropdownOpen && (
            <Row>
              <div className="text-sm-end">
                {isNewUserPermission &&
                  <Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2 me-2"
                    onClick={handleCustomerClicks}
                  >
                    <i className="mdi mdi-plus me-1" />
                    New User
                  </Button>
                }
              </div>
              <Col xs="12">
                <div className="table-responsive">
                  <Table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Id</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        {isUserStatusChangePerm && (<th>User Status</th>)}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userList.length == 0 ?
                        <tr>
                          <td colSpan={7} className="text-center">No data found</td>
                        </tr> :
                        (userList.map((elem, index) => (
                          <tr key={uId()}>
                            <td>{index + 1}</td>
                            <td>{elem.firstName || "-"}</td>
                            <td>{elem.lastName || "-"}</td>
                            <td>{elem.email}</td>
                            <td>{elem.mobileNo}</td>
                            {isUserStatusChangePerm && (<td>
                              <TableActionsComponentToggle
                                props={elem}
                                handleStatusChange={(newObj) => {
                                  handleStatusChange(newObj);
                                }}
                              />
                            </td>)}
                            <td>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="card-drop">
                                  <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                </DropdownToggle>

                                <DropdownMenu className="dropdown-menu-end">
                                  <DropdownItem
                                    onClick={() => {
                                      EditAddress(elem.id);
                                    }}
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-16 text-success me-1"
                                      id="edittooltip"
                                    ></i>
                                    Edit
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="edittooltip"
                                    >
                                      Edit
                                    </UncontrolledTooltip>
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => {
                                      ViewUser(elem.id);
                                    }}
                                  >
                                    <i
                                      className="mdi mdi-eye font-size-16 text-success me-1"
                                      id="viewtooltip"
                                    ></i>
                                    View
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="viewtooltip"
                                    >
                                      View
                                    </UncontrolledTooltip>
                                  </DropdownItem>

                                 {elem.isConsentDays == 1 && isPermissionReqConsent && ( <DropdownItem
                                    onClick={() => {
                                      handleChange(elem.id);
                                    }}
                                  >
                                    <i
                                      className="mdi mdi-check font-size-16 text-info me-1"
                                      id="viewtooltip"
                                    ></i>
                                    Request Consent
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="viewtooltip"
                                    >
                                      Request Consent
                                    </UncontrolledTooltip>
                                  </DropdownItem>)}
                                  <DropdownItem
                                        onClick={() => {
                                            deleteDetail(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-delete font-size-16 text-success me-1"
                                        id="deletetooltip"
                                        ></i>
                                        Delete
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="deletetooltip"
                                        >
                                        Delete
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          )}
        </Card>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
       {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogAction}
        />
      }
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </div>
  );
}

export default UsersTable;
